import { knowledgeBaseSectionQuery } from "@/views/settings/base-knowledge/edit/gql/queries";

export const MAX_SECTION_NESTING = 6;

async function getApolloClient() {
  const { default: apolloClient } = await import("@/plugins/apollo-vue");

  return apolloClient;
}

function collectAncestors(section) {
  const ancestors = [];
  let parent = section?.parent;

  while (parent?.id) {
    ancestors.push({
      id: String(parent.id),
      name: parent.name,
    });
    parent = parent.parent;
  }

  return ancestors;
}

async function fetchKnowledgeBaseSection(id) {
  const apolloClient = await getApolloClient();
  const response = await apolloClient.query({
    query: knowledgeBaseSectionQuery,
    fetchPolicy: "network-only",
    variables: { id },
  });

  return response?.data?.knowledgeBaseSection || null;
}

export function canCreateSubsectionAtDepth(depth) {
  return Number.isInteger(depth) && depth + 1 < MAX_SECTION_NESTING;
}

export async function getKnowledgeBaseSectionMeta(sectionId) {
  const current = await fetchKnowledgeBaseSection(sectionId);

  if (!current) {
    return {
      id: null,
      name: null,
      depth: 0,
      parentId: null,
      parentName: null,
    };
  }

  const ancestors = collectAncestors(current);
  const parentId = current.parentId ? String(current.parentId) : null;

  return {
    id: String(current.id),
    name: current.name,
    depth: ancestors.length,
    parentId,
    parentName: ancestors[0]?.name || null,
  };
}
